const PROD_COS_BASE_URL = 'https://px-cdn.ssv.tencent.com/fe-ssv-web';
const TEST_COS_BASE_URL = 'https://px-cdn-test.ssv.tencent.com/fe-ssv-web';

function getCosBaseUrl() {
  if (typeof window !== 'undefined' && window.location?.host) {
    return window.location.host.includes('test') ? TEST_COS_BASE_URL : PROD_COS_BASE_URL;
  }

  const appEnv = process.env.NEXT_PUBLIC_APP_ENV || process.env.APP_ENV;
  return appEnv === 'production' ? PROD_COS_BASE_URL : TEST_COS_BASE_URL;
}

export function getCosImageUrl(path: string, quality = 100) {
  if (!path) return '';
  if (/^(https?:)?\/\//.test(path) || path.startsWith('data:')) return path;

  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const lowerPath = cleanPath.toLowerCase().split('?')[0];
  const extIndex = lowerPath.lastIndexOf('.');
  const ext = extIndex >= 0 ? lowerPath.slice(extIndex + 1) : '';
  const needSuffix = ['jpg', 'webp', 'tpg', 'heif', 'avif'].includes(ext);
  const suffix = needSuffix ? `?imageMogr2/quality/${quality}` : '';

  return `${getCosBaseUrl()}${cleanPath}${suffix}`;
}
